<div class="row pg-style profile-page">
  <div class="col-sm-12 pg-style">
    <div class="row search-banner">
      <div class="col-sm-12 search-banner-col">
        <h2 class="h3 search-banner-title">Profile</h2>
      </div>
    </div>

    <div class="row search-nav">
      <div class="col-sm-12 search-nav-col">
        <ul class="list-inline search-nav-list">
          <li>
            <a routerLink="/profile/authorizations" [class.search-nav-active]="selectedTab() === 'authorizations'">Authorizations</a>
          </li>
          <li>
            <a routerLink="/profile/updatePassword" [class.search-nav-active]="selectedTab() === 'updatePassword'">Password Management</a>
          </li>
          <li>
            <a routerLink="/profile/mfa" [class.search-nav-active]="selectedTab() === 'mfa'">Login Authentication</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="row search-comp">
      <div class="card col-sm-12">
        @if (selectedTab() === 'authorizations') {
          <bmt-profile-authorizations></bmt-profile-authorizations>
        }

        @if (selectedTab() === 'updatePassword') {
          <bmt-update-password></bmt-update-password>
        }

        @if (selectedTab() === 'mfa') {
          <div class="multi-factor-component">
            <lib-multi-factor
              appName="BMT"
              layout="stacked"
              [enableEmailFactor]="true"
              [multifactorLabels]="multifactorLabels"></lib-multi-factor>
          </div>
        }
      </div>
    </div>
  </div>
</div>
